// extracted by mini-css-extract-plugin
module.exports = {"overflowButton":"IconMenu_overflowButton__38Vw6","disabledItem":"IconMenu_disabledItem__HsRMT"};